export const GET_PHAN_QUYEN_TIN_CHAP = 'GET_PHAN_QUYEN_TIN_CHAP';
export const GET_PHAN_QUYEN_TIN_CHAP_SUCCESS =
  'GET_PHAN_QUYEN_TIN_CHAP_SUCCESS';
export const GET_PHAN_QUYEN_TIN_CHAP_FAILURE =
  'GET_PHAN_QUYEN_TIN_CHAP_FAILURE';
export const GET_PHAN_QUYEN_CAM_DO = 'GET_PHAN_QUYEN_CAM_DO';
export const GET_PHAN_QUYEN_CAM_DO_SUCCESS = 'GET_PHAN_QUYEN_CAM_DO_SUCCESS';
export const GET_PHAN_QUYEN_CAM_DO_FAILURE = 'GET_PHAN_QUYEN_CAM_DO_FAILURE';

export const GET_PHAN_QUYEN_NO_PHAI_THU = 'GET_PHAN_QUYEN_NO_PHAI_THU';
export const GET_PHAN_QUYEN_NO_PHAI_THU_SUCCESS =
  'GET_PHAN_QUYEN_NO_PHAI_THU_SUCCESS';
export const GET_PHAN_QUYEN_NO_PHAI_THU_FAILURE =
  'GET_PHAN_QUYEN_NO_PHAI_THU_FAILURE';

export const GET_PHAN_QUYEN_TRA_GOP = 'GET_PHAN_QUYEN_TRA_GOP';
export const GET_PHAN_QUYEN_TRA_GOP_SUCCESS = 'GET_PHAN_QUYEN_TRA_GOP_SUCCESS';
export const GET_PHAN_QUYEN_TRA_GOP_FAILURE = 'GET_PHAN_QUYEN_TRA_GOP_FAILURE';
